<template>
  <div>
    <template>
      <h4
          class="not-margin"
          :style="{
          fontWeight: 'bold',
          color: '#195BFF',
          fontSize: '18px',
          marginTop: '10px',
        }"
      >
        <i
            class="fal fa-info-circle"
            :style="{ width: '30px', fontSize: '18px' }"
        ></i>
        {{ $t("shopItem.add_item_title") }}
      </h4>
    </template>

    <!-- type -->
    <div class="field columns column" style="margin-bottom: -30px">
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.item_type") }}
            <span class="text-danger">* {{ errors.first("item_type") }}</span>
            <span class="text-danger">
              {{ server_errors.item_type }}
            </span>
          </label>
          <div class="select">
            <select class="input" v-model="value.item_type">
              <option value="item">{{ $t("shopItem.item_type_item") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.category") }}
            <span class="text-danger">* {{ errors.first("item_category_id") }}</span>
            <span class="text-danger">
              {{ server_errors.item_category_id }}
            </span>
          </label>
          <model-list-select
              :list="itemCategory"
              v-model="value.item_category_id"
              :placeholder="$t('shopItem.select_category')"
              option-text="name"
              option-value="id"
              selectedItem="name"
              name="shop_id"
          >
          </model-list-select>
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            flash sale
            <span class="text-danger">* {{ errors.first("flash_sale_status") }}</span>
            <span class="text-danger">
              {{ server_errors.flash_sale_status }}
            </span>
          </label>
          <div class="select">
            <select class="input" v-model="value.flash_sale_status">
              <option value="off">{{ $t("shopItem.status_off") }}</option>
              <option value="on">{{ $t("shopItem.status_on") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column" v-if="value.flash_sale_status === 'on'">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.flash_sale_end_field") }}
            <span class="text-danger">* {{ errors.first("end_flash_sale") }}</span>
            <span class="text-danger">
              {{ server_errors.end_flash_sale }}
            </span>
          </label>
          <date-picker
              format="DD/MM/YYYY HH:mm:ss"
              value-type="YYYY-MM-DD HH:mm:ss"
              type="datetime"
              v-model="value.end_flash_sale"
              :clearable="false"
              name="end_flash_sale"
          ></date-picker>
        </div>
      </div>
    </div>

    <!--SHOP name and price-->
    <div class="field columns column" style="margin-bottom: -30px">
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.store") }}
            <span class="text-danger">* {{ errors.first("shop_id") }}</span>
            <span class="text-danger">
              {{ server_errors.shop_id }}
            </span>
          </label>
          <model-list-select
              :list="shops"
              v-model="value.shop_id"
              :placeholder="$t('shopItem.select_shop')"
              option-text="name"
              option-value="id"
              selectedItem="name"
              name="shop_id"
          >
          </model-list-select>
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.name") }}
            <span class="text-danger">* {{ errors.first("name") }}</span>
            <span class="text-danger">
              {{ server_errors.name }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="name"
              :placeholder="$t('shopItem.placeholder_enter_first')"
              v-model="value.name"
              v-validate="'required|max:191'"
          />
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.exchange_points") }}
            <span class="text-danger">* {{ errors.first("price") }}</span>
            <span class="text-danger">
              {{ server_errors.price }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="price"
              :placeholder="$t('shopItem.placeholder_enter_first')"
              v-model="value.price"
              v-validate="'required|numeric'"
          />
        </div>
      </div>
    </div>

    <div class="field columns column" style="margin-bottom: -30px">
      <div class="column" v-if="value.flash_sale_status === 'on'">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.flash_sale_exchange_points") }}
            <span class="text-danger">* {{ errors.first("flash_sale_price") }}</span>
            <span class="text-danger">
              {{ server_errors.flash_sale_price }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="flash_sale_price"
              :placeholder="$t('shopItem.placeholder_enter_first')"
              v-model="value.flash_sale_price"
          />
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.item_cost") }}
            <span class="text-danger">* {{ errors.first("item_cost") }}</span>
            <span class="text-danger">
              {{ server_errors.item_cost }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="item_cost"
              :placeholder="$t('shopItem.placeholder_enter_first')"
              v-model="value.item_cost"
              v-validate="'required|numeric'"
          />
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.end_available_date") }}
            <span class="text-danger">* {{ errors.first("end_available") }}</span>
            <span class="text-danger">
              {{ server_errors.end_available }}
            </span>
          </label>
          <date-picker
              format="DD/MM/YYYY HH:mm:ss"
              value-type="YYYY-MM-DD HH:mm:ss"
              type="datetime"
              v-model="value.end_available"
              :clearable="true"
              name="end_available"
          ></date-picker>
        </div>
      </div>
    </div>

    <!-- qty, amount per user and day -->
    <div class="field columns column" style="margin-bottom: -30px">
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.quantity") }}
            <span class="text-danger"> {{ errors.first("qty") }}</span>
            <span class="text-danger">
              {{ server_errors.qty }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="qty"
              :placeholder="$t('shopItem.placeholder_blank_unlimited')"
              v-model="value.qty"
          />
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.amount_per_user") }}
            <span class="text-danger"> {{ errors.first("amount_per_user") }}</span>
            <span class="text-danger">
              {{ server_errors.amount_per_user }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="amount_per_user"
              :placeholder="$t('shopItem.placeholder_blank_unlimited')"
              v-model="value.amount_per_user"
          />
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.amount_per_day") }}
            <span class="text-danger"
            > {{ errors.first("amount_per_day") }}</span
            >
            <span class="text-danger">
              {{ server_errors.amount_per_day }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="amount_per_day"
              :placeholder="$t('shopItem.placeholder_blank_unlimited')"
              v-model="value.amount_per_day"
          />
        </div>
      </div>
    </div>

    <div class="field columns column" style="margin-bottom: -30px">
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.pickup_duration") }}
            <span class="text-danger">* {{ errors.first("expired_duration") }}</span>
            <span class="text-danger">
              {{ server_errors.expired_duration }}
            </span>
          </label>
          <input
              class="input"
              type="text"
              name="expired_duration"
              :placeholder="$t('shopItem.placeholder_blank_unlimited')"
              v-model="value.expired_duration"
          />
        </div>
      </div>
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.item_status") }}
            <span class="text-danger">* {{ errors.first("status") }}</span>
            <span class="text-danger">
              {{ server_errors.status }}
            </span>
          </label>
          <div class="select">
            <select class="input" v-model="value.item_status">
              <option value="0">{{ $t("shopItem.status_off") }}</option>
              <option value="1">{{ $t("shopItem.status_on") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="field columns column" style="margin-bottom: -20px">
      <div class="column">
        <div class="control">
          <label class="label">
            {{ $t("shopItem.description") }}
            <span class="text-danger"> {{ errors.first("description") }}</span>
            <span class="text-danger">
              {{ server_errors.description }}
            </span>
          </label>
          <textarea
              class="textarea"
              v-model="value.description"
          />
        </div>
      </div>
    </div>
    <!-- icon -->
    <div class="field column" style="margin-bottom: -20px">
      <div class="control">
        <label class="label">
          {{ $t("shopItem.image") }}
          <span class="text-danger"
          > {{ errors.first("image") }}</span
          >
          <span class="text-danger">
              {{ server_errors.image }}
            </span>
        </label>
        <div id="my-strictly-unique-vue-upload-multiple-image"
             style="display: flex; justify-content: center; margin-top: 5px">
          <vue-upload-multiple-image
              accept="image/jpeg,image/png,image/jpg"
              :maxImage="5"
              :dragText="$t('shopItem.drag_text_max_images', { n: 5 })"
              :showPrimary="false"
              :browse-text="$t('shopItem.browse_images')"
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
          ></vue-upload-multiple-image>
        </div>
      </div>
    </div>

    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button
            ref="button"
            flat
            @click="ValidateForm()"
            class="form-btn-loading"
            :loading="loading"
        >{{ $t("shopItem.save_item_button") }}
        </vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import {Validator} from "vee-validate";
import {ModelListSelect} from 'vue-search-select';
import DatePicker from "vue2-datepicker";
import moment from "moment";
import VueUploadMultipleImage from 'vue-upload-multiple-image'

export default {
  components: {
    ModelListSelect,
    DatePicker,
    VueUploadMultipleImage
  },
  data() {
    return {
      active: false,
      isLoading: false,
      loading: false,
      shops: [],
      shop_type: '',
      isParent: '',
      itemCategory: [],
      server_errors: {
        item_type: "",
        item_category_id: '',
        shop_id: "",
        name: "",
        price: "",
        item_cost: "",
        description: "",
        qty: "",
        status: "",
        image: "",
        amount_per_user: "",
        amount_per_day: "",
        end_available: "",
        expired_duration: "",
        flash_sale_status: "",
        end_flash_sale: "",
      },
      value: {
        item_type: "item",
        item_category_id: '',
        shop_id: "",
        name: "",
        price: "",
        item_cost: "",
        description: "",
        qty: "",
        item_status: 0,
        images: [],
        amount_per_user: "",
        amount_per_day: "",
        flash_sale_status: "off",
        expired_duration: "",
        end_available: moment(new Date()).format('YYYY-MM-DD 23:59:59'),
        end_flash_sale: moment(new Date()).format('YYYY-MM-DD 23:59:59'),
      },
    };
  },
  created() {
    const dict = {
      custom: {
        name: {
          required: `(${this.$t('validator.required')}...)`,
          max: `(${this.$t('validator.max_character', { max: 191 })}...)`,
        },
        price: {
          required: `(${this.$t('validator.required')}...)`,
          numeric: `(${this.$t('validator.numeric')}...)`,
        },
        item_cost: {
          required: `(${this.$t('validator.required')}...)`,
          numeric: `(${this.$t('validator.numeric')}...)`,
        },
      },
    };
    Validator.localize("en", dict);

    if (this.$can('marketinghelper')) {
      this.shop_type = 'other'
      this.isParent = 'no'
    } else {
      this.shop_type = '';
      this.isParent = ''
    }
    this.listShop();
    this.listItemCategory();
  },
  methods: {
    uploadImageSuccess(formData) {
      this.value.images.push(formData.get('file'))
    },
    beforeRemove(index, done) {
      const r = confirm(this.$t('shopItem.confirm_delete_image'));
      if (r === true) {
        done()
      }
    },
    listShop() {
      this.$http.get('list/shop/' + '?type=' + this.shop_type + '&isParent=' + this.isParent).then((res) => {
        this.shops = res.data;
      })
    },
    listItemCategory() {
      this.$http.get('list/shop/item/category').then((res) => {
        this.itemCategory = res.data;
      })
    },
    ValidateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.SaveItem();
        }
      });
    },
    SaveItem() {
      this.loading = true;
      let formData = new FormData();
      formData.append('item_type', this.value.item_type);
      formData.append('item_category_id', this.value.item_category_id);
      formData.append('flash_sale_status', this.value.flash_sale_status);
      formData.append('shop_id', this.value.shop_id);
      formData.append('name', this.value.name);
      formData.append('price', this.value.price);
      formData.append('item_cost', this.value.item_cost);
      formData.append('status', this.value.item_status);
      formData.append('description', this.value.description ?? '');
      formData.append('qty', this.value.qty ?? '');
      formData.append('amount_per_user', this.value.amount_per_user ?? '');
      formData.append('amount_per_day', this.value.amount_per_day ?? '');
      formData.append('end_available', this.value.end_available ?? '');
      formData.append('end_flash_sale',
          (this.value.flash_sale_status === 'on')
              ? (this.value.end_flash_sale ?? '')
              : '');
      formData.append('flash_sale_price',
          (this.value.flash_sale_status === 'on')
              ? (this.value.flash_sale_price ?? '')
              : '');
      formData.append('expired_duration', this.value.expired_duration);
      this.value.images.map((item) => {
        formData.append('image[]', item);
      });
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      }
      this.$http.post('add/shop/item', formData, config).then(() => {
        this.loading = false;
        this.$emit('close');
        this.$emit('success');
      })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 422) {
              const obj = error.response.data.errors; // ໃຊ້ການລູບຂໍ້ມູນເພາະວ່າຂໍ້ມູນ errors ທີ່ສົ່ງມາຈາກ Server ນັ້ນເປັນ Array Object
              for (let [key, value] of Object.entries(obj)) {
                this.server_errors[key] = value[0];
              }
            }
          });
    },
    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.button,
        scale: "0.6",
        background: "primary",
        opacity: 1,
        color: "#fff",
      });
    },
  },
  mounted() {
    if (this.$can('marketinghelper')) {
      this.shop_type = 'other'
      this.isParent = 'no'
    } else {
      this.shop_type = '';
      this.isParent = ''
    }
  },
  watch: {
    "value.item_type": function () {
      this.server_errors.item_type = "";
    },
    "value.item_category_id": function () {
      this.server_errors.item_category_id = "";
    },
    "value.shop_id": function () {
      this.server_errors.shop_id = "";
    },
    "value.name": function () {
      this.server_errors.name = "";
    },
    "value.price": function () {
      this.server_errors.price = "";
    },
    "value.item_cost": function () {
      this.server_errors.item_cost = "";
    },
    "value.qty": function () {
      this.server_errors.qty = "";
    },
    "value.expired_duration": function () {
      this.server_errors.expired_duration = "";
    },
    "value.amount_per_user": function () {
      this.server_errors.amount_per_user = "";
    },
    "value.amount_per_day": function () {
      this.server_errors.amount_per_day = "";
    },
    "value.end_available": function () {
      this.server_errors.end_available = "";
    },
    "value.end_flash_sale": function () {
      this.server_errors.end_flash_sale = "";
    },
  },
};
</script>
<style lang="scss" scoped>
#my-strictly-unique-vue-upload-multiple-image {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.has-profile {
  border: none;
  height: 200px;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-size: 300px;
  background-position: center;

  &:hover {
    cursor: pointer;
  }
}

.box-upload-file {
  border: 1px dashed rgba(100, 98, 98, 0.867);
  height: 200px;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    border: 1px dashed $primary-color;

    .text-msg {
      i {
        color: $primary-color;
      }

      p {
        color: $primary-color;
      }
    }
  }

  .text-msg {
    i {
      font-size: 25px;
      color: rgba(100, 98, 98, 0.867);
    }

    .choose {
      margin-top: 10px;
      color: rgba(100, 98, 98, 0.867);
    }
  }
}
</style>
